import { AnyAction } from "redux";
import {
  SET_PROFILE,
  RESET_PROFILE,
  SET_GROUP_CODE,
  SET_ENTITY,
  SET_OPERATION,
  SET_LANGUAGE,
  SET_RECORDS_PER_PAGE,
  SET_TEST_ENVIRONMENT,
  SET_PERMISSIONS,
  SET_DEFAULT_PERMISSIONS,
  SET_PERMISSION_NODES,
  SET_GROUPCODE_PERMISSION,
  SET_ENTITY_PERMISSION,
  SET_USER_PERMISSIONS,
  SET_USER_HAS_PERMISSIONS,
  SET_NOTIFICATIONS,
  SET_ACCESS_TOKEN,
  SET_LEGACY_MAPPING_FROM_FIELD_FILTER,
  SET_LEGACY_MAPPING_TO_FIELD_FILTER,
  SET_LEGACY_MAPPING_COMMENTS_FILTER, SET_REPORT, SET_EXTRACTION_RESULT_TABLE_PARAMS
} from "./actions";

const initialState = {
  profile: null,
  recordsPerPage: 20,
  legacyMappingFromFieldFilter: true,
  legacyMappingToFieldFilter: true,
  legacyMappingCommentsFilter: true,
};

export default function reducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    case SET_PROFILE:
      return { ...state, profile: action.payload };
    case SET_GROUP_CODE:
      return { ...state, groupCode: action.payload };
    case SET_ENTITY:
      return { ...state, entity: action.payload };
    case SET_OPERATION:
      return { ...state, operation: action.payload };
    case SET_REPORT:
      return { ...state, report: action.payload };
    case SET_LANGUAGE:
      return { ...state, language: action.payload };
    case SET_RECORDS_PER_PAGE:
      return { ...state, recordsPerPage: action.payload };
    case SET_TEST_ENVIRONMENT:
      return { ...state, testEnvironment: action.payload };
    case RESET_PROFILE:
      return { ...state, profile: action.payload };
    case SET_PERMISSIONS:
      return { ...state, permissions: action.payload };
    case SET_DEFAULT_PERMISSIONS:
      return { ...state, defaultPermissions: action.payload };
    case SET_GROUPCODE_PERMISSION:
      return { ...state, groupCodePermissions: action.payload };
    case SET_ENTITY_PERMISSION:
      return { ...state, entityPermissions: action.payload };
    case SET_USER_PERMISSIONS:
      return { ...state, userPermissions: action.payload };
    case SET_USER_HAS_PERMISSIONS:
      return { ...state, userHasPermissions: action.payload };
    case SET_NOTIFICATIONS:
      return { ...state, notifications: action.payload };
    case SET_ACCESS_TOKEN:
      return { ...state, profile: { ...state.profile, accessToken: action.payload } };
    case SET_LEGACY_MAPPING_FROM_FIELD_FILTER:
      return { ...state, legacyMappingFromFieldFilter: action.payload };
    case SET_LEGACY_MAPPING_TO_FIELD_FILTER:
      return { ...state, legacyMappingToFieldFilter: action.payload };
    case SET_LEGACY_MAPPING_COMMENTS_FILTER:
      return { ...state, legacyMappingCommentsFilter: action.payload };
    case SET_EXTRACTION_RESULT_TABLE_PARAMS:
      return { ...state, extractionResultTableParams: action.payload };
    default:
      return state;
  }
}
